module.exports = __webpack_public_path__ + "img/Party-241204.4d99bbec.png";